
export default {
    name: 'LocationServices',
    props: {
        location: {
            type: Object,
            required: true,
        },
        radius: {
            type: Number,
            required: true,
        },
        stats: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            jobs: [],
        };
    },
    async fetch() {
        await this.$store.dispatch('services/get');
        if (!this.location.lat) {
            return;
        }
        const jobs = await this.$axios.$get(this.$config.endpoints.publicJob, {
            params: {
                per_page: 2,
                status: ['accepted', 'paid', 'collected', 'completed'],
                inLocation: true,
                lat: this.location.lat,
                lon: this.location.lon,
                radius: this.radius,
            },
        });
        this.jobs = jobs?.jobs?.data || [];
    },
    computed: {
        sections() {
            const sections = [
                {
                    title: this.$t('services.location.why_use_clearwaste'),
                    text: this.$t('services.location.why_use_clearwaste_text'),
                    image: '/images/services/location',
                    imageAlt: 'Fly-tipping dumped on the side of a road',
                },
                {
                    title: this.$t('services.location.our_trusted_traders_guarantee'),
                    text: this.$t('services.location.our_trusted_traders_guarantee_text'),
                    image: '/images/services/app',
                    imageAlt: 'The ClearWaste mobile app',
                },
                {
                    stats: true,
                },
                {
                    id: 'skip',
                    title: this.$t('services.location.skip_hire_in', { location: this.location.name }),
                    text: this.$t('services.skip_hire.skip_contents.text'),
                    image: '/images/jobs/skip.svg',
                    imageAlt: 'Lorry carrying a skip.',
                    service: 2,
                    skips: true,
                    traders: true,
                },
                {
                    id: 'bag',
                    title: this.$t('services.location.grab_bag_in', { location: this.location.name }),
                    text: this.$t('services.grab_bag.bag_contents.text'),
                    image: '/images/jobs/grab.svg',
                    imageAlt: 'Two men removing a grab bag.',
                    bags: true,
                    traders: true,
                    service: 3,
                },
                {
                    id: 'van',
                    title: this.$t('services.location.man_and_van_in', { location: this.location.name }),
                    text: this.$t('services.van.van_contents.text'),
                    image: '/images/jobs/van.svg',
                    imageAlt: 'Man next to a van.',
                    service: 1,
                    van: true,
                    traders: true,
                },
            ];
            if (this.jobs.length) {
                sections.push({
                    title: this.$t('services.location.recent_jobs'),
                    text: this.$t('services.location.recent_jobs_text'),
                    jobs: true,
                });
            }
            return sections;
        },
    },
};
